declare global {
    interface Window {
        iFrameResizer: any;
    }
}

import Cookies from 'js-cookie';
import { addClickEventListener, wrapPreventDefault } from '../util/event';
import LocalStorageWithFallback from "./localStorageWithFallback";

const COOKIE_MESSAGE_CONTAINER_SELECTOR = '.c-cookie-message';
const COOKIE_MESSAGE_CONTENT_SELECTOR = '.c-cookie-message__content';
const COOKIE_MESSAGE_CLOSE_SELECTOR = '[data-close-cookie]';
const COOKIE_MESSAGE_CLOSE_LINK_SELECTOR = '[data-link-close-cookie]';
const CONSENT_COOKIE = 'consent-cookie';
const API_ENDPOINT = '/de/api/cookies';
const expirationTime = 730;
const localStorageWithFallback: LocalStorageWithFallback = new LocalStorageWithFallback();

export function showCookieMessageIfNotAccepted(): void {
    const container = document.querySelector(COOKIE_MESSAGE_CONTAINER_SELECTOR);
    const closeCookie = document.querySelector<HTMLElement>(COOKIE_MESSAGE_CLOSE_LINK_SELECTOR);

    if (container === null || !closeCookie) {
        return;
    }

    if (window.iFrameResizer) {
        const cookieContent = document.querySelector<HTMLElement>(COOKIE_MESSAGE_CONTENT_SELECTOR);
        if (cookieContent) {
            cookieContent.style.top = '300px';
        }
    }

    if (!localStorageWithFallback.get('cookie')) {
        container.classList.remove('hide');
    }

    document.querySelectorAll(COOKIE_MESSAGE_CLOSE_SELECTOR).forEach(e =>
        addClickEventListener(e, wrapPreventDefault(() => {
            const acceptAll = e.id == 'accept-all-cookies';

            container.classList.add('hide');
            localStorageWithFallback.set('cookie', 'is-set');

            getCookieParameters(API_ENDPOINT, acceptAll)
                .then(res => {
                    Cookies.set(CONSENT_COOKIE, res.toString(), { expires: expirationTime })
                });
        }))
    );

    addClickEventListener(closeCookie, () => {
        container.classList.add('hide');
    });
}

export function setCookies(): void {
    const checkboxArray = document.querySelectorAll<HTMLInputElement>('.js-cookie-checkbox');
    const checkboxSubmitButton = document.querySelector('#consent-save');
    const savedMessage = document.querySelector('.js-privacy-saved');
    const cookies = Cookies.get(CONSENT_COOKIE);
    const privacyModal = document.querySelector('.js-privacy-modal');

    if (checkboxSubmitButton) {
        checkboxSubmitButton.addEventListener('click', () => {
            const checkedCheckboxes = document.querySelectorAll<HTMLInputElement>('.js-cookie-checkbox:checked')

            if (savedMessage && privacyModal) {
                privacyModal.classList.remove('is-visible');
                savedMessage.classList.add('active');
                localStorageWithFallback.set('cookie', 'is-set');
                setTimeout(() => savedMessage.classList.remove('active'), 5000);
            }

            const consentCookies: Array<string> = [];
            checkedCheckboxes.forEach(checkbox => {
                consentCookies.push(checkbox.value);
            })

            Cookies.set(CONSENT_COOKIE, consentCookies.toString(), { expires: expirationTime });
        })
    }

    if (cookies) {
        const definedCookies = cookies.split(',');
        checkboxArray.forEach(checkbox => {
            checkbox.checked = definedCookies.includes(checkbox.value);
        })
    }
}

async function getCookieParameters(apiEndpoint: string, acceptAll: boolean = false): Promise<Array<string>> {
    const apiRequest = acceptAll ? apiEndpoint + '?accept-all=1' : apiEndpoint;
    const res = await fetch(apiRequest)

    if (!res.ok) {
        throw new Error(`request failed: got response code ${res.status}`);
    }

    const body = await res.json()

    return res.ok ? body.response : null
}
